var map = {
	"./tag2-不可累计房晚和积分.svg": "cd6e",
	"./tag2-专属价.svg": "9e7a",
	"./tag2-会员专属价.svg": "b341",
	"./tag2-免费取消.svg": "ca4a",
	"./tag2-入住前一天免费取消.svg": "39ad",
	"./tag2-固定价.svg": "3ca7",
	"./tag2-累计积分.svg": "0cbd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4382";